import { cn } from '@/lib/utils';
import type { AirQualityStatus } from '@/types/energy';
import { AIR_QUALITY_COLORS, AIR_QUALITY_LABELS } from '@/types/energy';

interface StatusIndicatorProps {
  status: AirQualityStatus;
  showLabel?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Colored status indicator dot with optional label
 * Uses EPA air quality threshold colors
 */
export function StatusIndicator({
  status,
  showLabel = true,
  size = 'sm',
  className,
}: StatusIndicatorProps) {
  const color = AIR_QUALITY_COLORS[status];
  const label = AIR_QUALITY_LABELS[status];

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <span
        className={cn(
          'rounded-full',
          size === 'sm' ? 'h-2 w-2' : 'h-2.5 w-2.5'
        )}
        style={{ backgroundColor: color }}
      />
      {showLabel && (
        <span
          className={cn(
            'font-medium',
            size === 'sm' ? 'text-[10px]' : 'text-xs'
          )}
          style={{ color }}
        >
          {label}
        </span>
      )}
    </div>
  );
}
